// import { TitleBar } from '@/services/Forms/Forms'
import { Checkbox_, Input_, Kotak, Select_, TitleBar } from '@/services/Forms/FormsSatu'
import { EditFilled, FileSearchOutlined, UploadOutlined } from '@ant-design/icons'
import { Checkbox, Form, Input, Select, Tabs } from 'antd'
import MainLayouts from 'layouts/MainLayouts'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Date_ } from 'services/Forms/Forms'
import { Button_, Number_, Switch_ } from 'services/Forms/FormsSatu'
import { msg } from 'services/Toastr/Notify/_Toastr'
import ChecklistPolaMakan from './ChecklistPolaMakan'
import FormHidanganSehari from 'pages/FormHidanganSehari/FormHidanganSehari'
import { HAPUS_IFUNDEFINE } from 'services'
import _Api from 'services/Api/_Api'
import moment from 'moment'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'
import 'dayjs/locale/id'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min.js'

dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.locale('id')

function IdentitasPasienBaru(pr) {

    const [frm] = Form.useForm()

    const [data, setdata] = useState([])
    const [agama, setagama] = useState()
    const [jeniskelamin, setjeniskelamin] = useState()
    const [pendidikan, setpendidikan] = useState()
    const [listDiet, setlistDiet] = useState([])

    const FORM_ID = 2
    const KONSELING_ID = pr.konseling_id

    const getCombo = () => {
        _Api.get("/get-combo-form?form_id=" + FORM_ID + "&konseling_id=" + KONSELING_ID).then(res => {
            // setcombo(res)
            var dt = res.data.combo
            // var rc = res.data.record
            // var konseling = res.data.konseling?.pembeli
 
            const agama = dt.filter(x => x.kelompok_id == "2")
            setagama(agama)

            const jk = dt.filter(x => x.kelompok_id == "1")
            setjeniskelamin(jk)

            const pdd = dt.filter(x => x.kelompok_id == "3")
            setpendidikan(pdd)
        })
    }
    var histori = useHistory()
    const simpanData = () => {
        // console.log(val)
        // debugger
        frm.validateFields().then(val => {
            var pure = HAPUS_IFUNDEFINE(val)
            var obj = {
                konseling_id: KONSELING_ID,
                form_id: FORM_ID,
                // diet : ,
                data: { 
                    ...pure, 
                    pembeli_id : pr.pembeli_id ?? "",
                    // diet: pure.diet && pure.diet.length > 0 ? pure.diet.toString() : "",
                    // diitsebelumnya: pure.diitsebelumnya && pure.diitsebelumnya.length > 0 ?  pure.diitsebelumnya.toString() :"",
                }
            }
            _Api.post("simpan-form-konseling-with-identitas", obj).then(rs => {
                msg.auto(rs.data)
                if(rs.data.sts == 1){
                        histori.push("/RiwayatKonselingGizi")
                }
            })
        }).catch(err => {
            console.log(err)
            msg.error("Silahkan lengkapi data ")
        })
    }
    const cariPasienSimrs = () =>{
        const norm = frm.getFieldValue("rm")
        _Api.get(`get-data-pasien?norm=${norm}`).then(r=>{
            const dtps = r.data.data
            console.log(dtps)
            const fr = {
                rm : dtps.nocm,    
                nama : dtps.namapasien,    
                alamat : dtps.alamatlengkap,    
                alergi : dtps.alergi,    
                noidentitas : dtps.noidentitas,    
                nohp : dtps.notelepon,    
                tgllahir : dtps.tgllahir ? dayjs(dtps.tgllahir, 'YYYY-MM-DD HH:mm') : null,
                jeniskelamin_id :dtps.jeniskelamin[0],    
            } 
            frm.setFieldsValue(fr)
            setTimeout(() => {
                hitungUmur()
            }, 200);
        })
    }
    const hitungIMT = () => { 
        var bb = frm.getFieldValue("bb") ?? 0
        var tb = frm.getFieldValue("tb") ?? 0
        var imt = (bb / (tb * tb) * 10000).toFixed(2)
        frm.setFieldsValue({ "imt": imt })
    }

    useEffect(() => {
        getCombo()
        // frm.setFieldsValue({ "centang": { "jagung_1": true, } })
    }, [])
 

    const hitungUmur = () => {
        var tgl = frm.getFieldValue("tgllahir")
        var umur = dayjs().diff(tgl, 'year').toString()
        frm.setFieldsValue({ "umur": umur })
    }
   
    return (
        <div className='border p-3 border-dark'>
            <div className='mb-2 '>
                <TitleBar label="Identitas Pasien" />
            </div>
            <Form layout='vertical' form={frm}

                // initialValues={{
                //     centangya: true, // Single checkbox initial value
                //   }}
                onFinish={simpanData}>
                <fieldset >
                    <Row className='p-1'>
                        <Input_ label="No. RM" sm="2" name="rm" addonAfter={<FileSearchOutlined onClick={cariPasienSimrs}></FileSearchOutlined>} />
                        <Input_ label="Nama" required sm="5" name="nama" />
                        <Select_ label="Jenis Kelamin" required sm="2" name="jeniskelamin_id" option={jeniskelamin} val="caption1" caption="caption" />
                        <Select_ label="Pendidikan" sm="2" name="pendidikan_id" option={pendidikan} val="id" caption="caption" />
                       
                        <Date_ label="Tanggal Lahir" onChange={hitungUmur} format="DD-MM-YYYY" required sm="3" name="tgllahir" />
                        <Input_ label="Umur" required sm="2" readOnly name="umur" addonAfter="Thn" />
                        <Number_  onChange={hitungIMT} required label="Tinggi Badan (TB)" sm="2" name="tb" addonAfter="cm" />
                        <Number_ onChange={hitungIMT} label="Berat Badan (BB)" required sm="2" name="bb" addonAfter="Kg" />
                        <Input_ disabled label="IMT" sm="2" name="imt" required />
                        <Input_  label="No. HP (WA)" sm="3" name="nohp" required />
                        {/* <Select_ label="Agama" sm="2" name="agama_id" option={agama} val="id" caption="caption" /> */}
                        {/* <Input_ label="Aktivitas" sm="3" name="aktivitas" /> */}
                        <Input_ label="Alamat" required sm="11" multiline name="alamat" />
                        <Input_ hidden  name="pembeli_id" />
                 
                    </Row>
                </fieldset>
                <Button_ sm="2" icon={<EditFilled />} block title="Simpan" onClick={simpanData} />

            </Form>
         
        </div>
    )
}
export default IdentitasPasienBaru;
